import { createActionType, createRequestActionTypes } from '../../helpers'

export const CREATE_USER_EVENT = createActionType(
  'USER_EVENTS',
  'CREATE_USER_EVENT'
)
export const CREATE_FOOTPRINT = createRequestActionTypes(
  'USER_EVENTS',
  'CREATE_FOOTPRINT'
)
export const CLEAR_FOOTPRINT = createActionType(
  'USER_EVENTS',
  'CLEAR_FOOTPRINT'
)



// WEBPACK FOOTER //
// ./src/containers/UserEvents/constants.js